export default __webpack_public_path__ + "static/media/errorBox.9a115b7f.png";